module.exports = __webpack_public_path__ + "img/how-to_image04.5847d4b7.png";